import React from 'react';
import {
    BrowserRouter as Router,
    Route,
    Switch,
    Redirect,
} from 'react-router-dom';

import InscreverTrabalho from './InscreverTrabalho';
import ListarEventos from './ListarEventos';
import ConsultarInscricoes from './ConsultarInscricoes';
import FinalizarInscricao from './FinalizarInscricao';
import Login from './Login';
import Error404 from './404';
// import RecuperarSenha from './RecuperarSenha';

class App extends React.Component {

    render() {
        return (
            <Router>
                <Switch>
                    <Route exact path="/" component={ListarEventos} />
                    <Route exact path="/404" component={Error404} />
                    <Route exact path="/inscricao/:evento_id" component={InscreverTrabalho} />
                    <Route exact path="/finalizar-inscricao/:evento_id/:token_inscricao" component={FinalizarInscricao} />
                    <Route exact path="/admin" component={ConsultarInscricoes} />
                    <Route exact path="/login" component={Login} />
                    {/* <Route exact path="/recuperar-senha" component={RecuperarSenha} /> */}
                    <Redirect to="/404" />
                </Switch>
            </Router>
        );
    }
}

export default App;